'use es6';

import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ONE_AM_UTC_PLUS_ONE_TIMESTAMP = 1722816000000;
export default function RevenueUpdateInfo() {
  return /*#__PURE__*/_jsxs(TFlex, {
    direction: "row",
    "data-test-id": "revenue-update-info",
    children: [/*#__PURE__*/_jsx(Text, {
      color: "text-tertiary-default",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "components.revenueAttributionCard.limitedAccess.revenueUpdateTime"
      })
    }), /*#__PURE__*/_jsx(HelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "components.revenueAttributionCard.limitedAccess.revenueUpdateInfo",
        options: {
          localTime: I18n.moment.portalTz(ONE_AM_UTC_PLUS_ONE_TIMESTAMP).format('h:mm A')
        }
      }),
      tooltipPlacement: "bottom",
      tooltipProps: {
        use: 'longform'
      },
      marginInlineStart: "200"
    })]
  });
}